import React from "react";
import { CircularProgress, Typography } from "@material-ui/core";
import styled from "styled-components";
import ErrorComponent from "../ErrorComponent";

const ToggleContents = styled.div`
  .hide {
    display: none;
  }
`;

const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
`;

const Centered = styled.div`
  margin: auto;
  text-align: center;
`;

export interface ILoadingProps {
  message: string;
  isLoading: boolean;
  setError?: Function;
  error?: string | Error;
  children: React.ReactNode;
}

export default class WithLoadingSpinners extends React.Component<ILoadingProps> {
  componentDidCatch(error: any, info: any) {
    if (this.props.setError) {
      this.props.setError(error);
    }
  }

  render() {
    if (this.props.error) {
      let msg = "Oops. Something went wrong...";
      if (typeof this.props.error === "object" && this.props.error.message) {
        msg = this.props.error.message;
      } else if (this.props.error.toString()) {
        msg = this.props.error.toString();
      }

      return <ErrorComponent msg={msg} />;
    }

    return (
      <ToggleContents>
        <div className={this.props.isLoading ? "show" : "hide"}>
          <Container>
            <Centered>
              <CircularProgress />
              <Typography variant="h4" component="h4">
                {this.props.message}
              </Typography>
            </Centered>
          </Container>
        </div>
        <div className={this.props.isLoading ? "hide" : "show"}>{this.props.children}</div>
      </ToggleContents>
    );
  }
}
